import {
    IIntegrationResponse,
    IntegrationResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { useQuery } from '@tanstack/react-query';
import { IntegrationDetails, IntegrationState } from 'pages/Settings/Integrations/types';
import { getIntegrationDetails } from 'utils/integration';
import { queryClient } from 'utils/query';

const queryKey = 'integration-settings';

export function useIntegrationSettings(
    locationId: string,
    integration: IIntegrationResponse | undefined
) {
    return useQuery<IntegrationDetails | undefined, Partial<Error>>({
        queryKey: [queryKey, locationId, integration?.SoftwareName],

        queryFn: () => {
            if (!integration) {
                return undefined;
            }
            return getIntegrationDetails(
                {
                    locationId,
                    integrationType: integration.IntegrationType,
                    state: integration.Active
                        ? IntegrationState.Active
                        : IntegrationState.Inactive,
                },
                new IntegrationResponse(integration)
            );
        },
    });
}

export function invalidateIntegrationSettings(softwareName: string, locationId: string) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, locationId, softwareName],
    });
}
